import { z } from "zod";

export const shiftTransferApiTypeAndId = z.object({
  id: z.string(),
  // type: z.literal(API_TYPES.shiftTransfer),
});

export const shiftTransferAttributesSchema = z.object({
  shiftId: z.string(),
  fromWorkerId: z.string(),
  toWorkerId: z.string(),
  transferredAt: z.coerce.date().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
});

export const shiftTransferDtoSchema = z.object({
  ...shiftTransferApiTypeAndId.shape,
  attributes: shiftTransferAttributesSchema,
});
